import * as React from 'react'

enum Status {
  'AVAILABLE',
  'UNAVAILABLE',
  'PENDING',
}

const shareBases = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
  pinterest: 'https://pinterest.com/pin/create/button/?url=',
  twitter: 'https://twitter.com/share?url=',
  linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=',
}

type ShareParams = {
  classic?: boolean
  title: string
  text: string
  url: string
  socialMedia?: 'facebook' | 'pinterest' | 'twitter' | 'linkedin'
}

export function useSocialShare(): {
  canNativelyShare: boolean
  isLoading: boolean
  share: (shareParams: ShareParams) => void
} {
  const [shareStatus, setShareStatus] = React.useState(Status.PENDING)

  React.useEffect(() => {
    const navigatorShare = window.navigator.share as typeof window.navigator.share | undefined

    setShareStatus(navigatorShare ? Status.AVAILABLE : Status.UNAVAILABLE)
  }, [])

  return {
    canNativelyShare: shareStatus === Status.AVAILABLE,
    isLoading: shareStatus === Status.PENDING,
    share,
  }
}

function share({ title, text, url, socialMedia, classic }: ShareParams) {
  if (classic) {
    socialMedia && openSharePopup(socialMedia, url)
  } else {
    navigator.share({
      title,
      text,
      url,
    })
  }
}

function openSharePopup(socialMedia: 'facebook' | 'pinterest' | 'twitter' | 'linkedin', url: string) {
  window.open(shareBases[socialMedia] + url, 'popup', 'height=650,width=650')
}
